import { Alert } from 'antd';
import classnames from 'classnames';
import React, { useEffect, useState, FC } from 'react';
import { getAxios } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { storageGet, storageSet } from '@/infrastructure/storage-utils';
import { useStores } from '@/presentation/store';
import style from './index.module.scss';

export const getLocalBanner = () => {
  try {
    return JSON.parse(storageGet('banner') ?? '');
  } catch (e) {
    return null;
  }
};

interface BannerData {
  closable?: boolean;
  content?: string;
  id?: string;
}

interface IProps {
  showBanner: boolean,
  setShowBanner: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Banner: FC<IProps> = (props) => {
  const { showBanner, setShowBanner } = props;
  const localBanner = getLocalBanner();
  const [bannerData, setBannerData] = useState<BannerData>({});
  const { loaded } = useStores().ProductStore;

  useEffect(() => {
    async function getBanner() {
      const notice = await getAxios().get(`/${API_PREFIX}/api/notice/board-msg-pro`);
      const bannerData = {
        closeable: notice?.data?.closable ?? false,
        content: notice?.data?.content ?? '',
        id: notice?.data?.id ?? '',
      };
      setBannerData(bannerData);
      const isShowBanner = (localBanner?.id !== notice?.data?.id || localBanner?.isShowBanner !== false)
        && !!notice?.data?.content;
      storageSet('banner', JSON.stringify({ ...bannerData, isShowBanner }));
      if (isShowBanner) {
        setShowBanner(true);
        return;
      }
      setShowBanner(false);
    }
    loaded && getBanner();
  }, [loaded]);

  return <Alert
    banner
    closable={bannerData.closable}
    showIcon={false}
    message={<div className={style.bannerMessage}>{bannerData.content}</div>}
    className={classnames(style.banner, showBanner ? '' : style.disableBanner)}
    onClose={() => {
      setShowBanner(false);
      storageSet('banner', JSON.stringify({ ...getLocalBanner(), isShowBanner: false }));
    }}
  />;
};
